export const UserTypes = Object.freeze({
  student: 'student',
  tutor: 'tutor',
  languageHelper: 'language_helper'
});
